/* Squish Deli help pages: small date helpers on top of sd-ui.js (CONTENT role).
   - [data-sd-today]           -> "Sat, Oct 17" (today in New York; honours ?sd_date= for QA)
   - [data-sd-timeline] > li   -> data-from / data-to (YYYYMMDD) mark .is-now / .is-past and the
                                  [data-sd-now] "You are here" sticker. Liquid renders the first paint. */
import { nyToday, formatShortDate } from '@theme/sd-ui';

function ymdNumber(d) {
  return Number(d.toISOString().slice(0, 10).replace(/-/g, ''));
}

function run(root = document) {
  const today = nyToday();
  const t = ymdNumber(today);

  for (const el of root.querySelectorAll('[data-sd-today]')) {
    el.textContent = formatShortDate(today, { weekday: true });
  }

  for (const list of root.querySelectorAll('[data-sd-timeline]')) {
    for (const step of list.children) {
      const from = Number(step.getAttribute('data-from') || 0);
      const to = Number(step.getAttribute('data-to') || 99999999);
      const now = t >= from && t <= to;
      step.classList.toggle('is-now', now);
      step.classList.toggle('is-past', t > to);
      const flag = step.querySelector('[data-sd-now]');
      if (flag) flag.hidden = !now;
      if (now) step.setAttribute('aria-current', 'step');
      else step.removeAttribute('aria-current');
    }
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(), { once: true });
else run();
document.addEventListener('shopify:section:load', (event) => run(/** @type {any} */ (event.target)));
